import { ChangeDetectionStrategy, Component, effect, model } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { tap } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { IconComponent } from '@examdojo/core/icon';
import { IconPickerComponent, IconPickerService, PickerIcon } from '@examdojo/core/icon-picker';
import { TextInputComponent } from '@examdojo/ui/input';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent } from '@examdojo/core/button';

@Component({
  selector: 'dojo-tag-emoji-picker',
  templateUrl: './tag-emoji-picker.component.html',
  styleUrl: './tag-emoji-picker.component.scss',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    IconPickerComponent,
    IconComponent,
    TextInputComponent,
    TranslocoModule,
    ButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagEmojiPickerComponent {
  constructor(private readonly iconPickerService: IconPickerService) {
    effect(() => {
      const emojiValue = this.selectedEmoji() ?? '';
      if (this.emojiCtrl.value !== emojiValue) {
        this.emojiCtrl.setValue(emojiValue, { emitEvent: false });
      }
    });

    this.emojiCtrl.valueChanges
      .pipe(
        tap((value: string) => {
          this.selectedEmoji.set(value || null);
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  readonly selectedEmoji = model<string | null>(null);
  readonly emojiCtrl = new FormControl<string>('', { nonNullable: true });

  onIconSelected(icon: PickerIcon): void {
    if (icon.emoji) {
      this.selectedEmoji.set(icon.emoji);
    }
  }

  clearSelection(): void {
    this.selectedEmoji.set(null);
  }

  selectRandomEmoji(): void {
    const emoji = this.iconPickerService.selectRandom();
    if (emoji) {
      this.selectedEmoji.set(emoji);
    }
  }
}
